// Implement the driver here.

let mode = 'local';

let extensionDriver = {
	_driver: 'extensionDriver',
	_initStorage: function(options) {
		return Promise.resolve();
		// Custom implementation here...
	},
	clear: function(callback) {
		// Custom implementation here...
	},
	async getItem(key, callback) {
		// Custom implementation here...sto
		let data = await browser.storage[mode].get(key);
		if (data[key]) {
			try {
				data = JSON.parse(data[key]);
				return data;
			} catch (err) {
				return data[key];
			}
		} else {
			return null;
		}
	},
	iterate: function(iteratorCallback, successCallback) {
		// Custom implementation here...
	},
	key: function(n, callback) {
		// Custom implementation here...
	},
	keys: function(callback) {
		// Custom implementation here...
	},
	length: function(callback) {
		// Custom implementation here...
	},
	async removeItem(key) {
		return browser.storage[mode].remove([key]);
	},
	setItem: function(key, value) {
		return new Promise(resolve => {
			let data = browser.storage[mode]
				.set({
					[key]: value
				})
				.then(status => {
					resolve(status);
				})
				.catch(err => {
					console.log(err);
				});
			return data;
		});
	}
};

export default extensionDriver;
